import classes from './SettingsPage.module.css';
import Categories from '../../../admin/Categories/Categories';
import Content from '../../../layouts/adminLayouts/Content/Content';
import Actions from '../../../layouts/adminLayouts/Actions/Actions';
import TypeOfFabric from '../../../admin/TypeOfFabric/TypeOfFabric';
import TypesOfFiller from '../../../admin/TypesOfFiller/TypesOfFiller';
import PromoCodes from '../../../admin/PromoCodes/PromoCodes';
import ProdGroups from '../../../admin/ProdGroups/ProdGroups';

const SettingsPage: React.FC = () => {
    return (
        <>
            <Actions title={'Настройки'} />

            <Content>
                <div className={classes.settings}>
                    <Categories />
                    <div className={classes.divider}>
                        <TypeOfFabric />
                        <TypesOfFiller />
                    </div>
                    <PromoCodes />
                    <div className={classes.divider}>
                        <ProdGroups />
                    </div>
                </div>
            </Content>
        </>
    );
};

export default SettingsPage;
